import { HBox } from "../box/Box";
import { IconMastercard } from "./IconMastercard";
import { IconVisa } from "./IconVisa";

export const IconVisaAndMaster = ({ width, height }: { width?: number; height?: number }) => {
	if (!width) width = 34;
	if (!height) height = 34;
	return (
		<HBox>
			<IconVisa width={width} height={height} />
			<IconMastercard width={width} height={height} />
		</HBox>
	);
};
